import { API_ENDPOINT as ACCOUNT_API_ENDPOINT } from './accountSchema';
import { API_ENDPOINT as COURSE_API_ENDPOINT } from './courseSchema';
import { API_ENDPOINT as UCC_API_ENDPOINT } from './uccSchema';

export const API_ENDPOINT = {
  ...UCC_API_ENDPOINT,
  ...ACCOUNT_API_ENDPOINT,
  ...COURSE_API_ENDPOINT,
};
